import { cn } from '@/lib/utils';
import GoogleIcon from '../../assets/icons/devicon_google.svg';

interface GoogleButtonProps {
	onClick?: () => void;
	className?: string;
}

const GoogleButton = ({ onClick, className }: GoogleButtonProps) => {
	return (
		<button
			className={cn(
				'box-border flex h-10 w-full items-center justify-center gap-2.5 rounded-lg border border-solid border-zinc-300 px-3 py-2 text-sm',
				className,
			)}
			onClick={(e) => {
				e.preventDefault();
				if (onClick) onClick();
			}}
		>
			<img src={GoogleIcon} alt="Google Logo" className="h-5 w-5" />
			<span className="font-medium text-dark">
				Continuar com o Google
			</span>
		</button>
	);
};

export { GoogleButton };
